<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="queryFirm"
      :selection="false"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>
  </div>
</template>

<script>
export default {
  name: "otaDeal",
  components: {},
  data() {
    return {
      url: "/battery/ota/firmPage",
      columns: [
        
        {
          label: "固件编号",
          prop: "firmSN",
        },
        {
          label: "固件名称",
          prop: "name",
        },
        {
          label: "应用项目",
          prop: "projectName",
        },
        {
          label: "固件版本",
          prop: "version",
        },
        {
          label: "备注",
          prop: "remark",
        },   
         {
          label: "更新时间",
          prop: "updateTime",
        }
      ], 
      queryFirm: [
        {
          label: "固件SN号",
          prop: "firmSN",
          placeholder: "请输入SN号",
        },
        {
          label: "固件名称",
          prop: "name",
          placeholder: "请输入固件名",
        },
        {
          label: "应用项目",
          prop: "projectName",
          placeholder: "请输入项目名称",
        },
        {
          label: "固件版本",
          prop: "version",
          placeholder: "请输入版本",
        },
        {
          label: "固件备注信息",
          prop: "remark",
          placeholder: "请输入固件备注关键字",
        }
       ],
    };
  },
  computed: {},
  methods: {
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/BMS/firmManagement/firmManagement.vue